// this gets replaced after the build completes if it's present in the Environment
export const WRITE_IN_DEV = false;
//# sourceMappingURL=_writeKey.js.map